"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jquery_1 = __importDefault(require("jquery"));
require("jquery.easing/jquery.easing");
var object_fit_images_1 = __importDefault(require("object-fit-images"));
(0, jquery_1.default)(document).ready(function () {
    (0, object_fit_images_1.default)('.objectFitImgs');
    common.init();
    var currentWidth = window.innerWidth;
    var currentHeight = window.innerHeight;
    window.addEventListener("resize", function () {
        if (currentWidth !== window.innerWidth || currentHeight !== window.innerHeight) {
            // $('body').hasClass('page-about') && about.resize();
        }
        else {
            return false;
        }
        currentWidth = window.innerWidth;
        currentHeight = window.innerHeight;
    }, false);
});
(0, jquery_1.default)(window).on('load', function () {
    common.loaded();
    common.scroll();
    (0, jquery_1.default)('body').addClass('is-loaded');
    (0, jquery_1.default)('body').hasClass('page-home') && (home.load(), home.scroll());
});
(0, jquery_1.default)(window).bind('scroll', function () {
    common.scroll();
    (0, jquery_1.default)('body').hasClass('page-home') && home.scroll();
});
(0, jquery_1.default)('body').bind('touchmove', function () {
    common.scroll();
    (0, jquery_1.default)('body').hasClass('page-home') && home.scroll();
});
var common = {
    init: function () {
        userAgent.init(), btnScroll.init();
        // SPナビゲーション開閉
        (0, jquery_1.default)(".js-spNavTrigger").on('click', function (event) {
            (0, jquery_1.default)(event.currentTarget).toggleClass("is-closed");
            (0, jquery_1.default)(".l-spNav").toggleClass("is-active");
            if ((0, jquery_1.default)(event.currentTarget).hasClass("is-closed")) {
                (0, jquery_1.default)("body").css({ overflow: "hidden" });
            }
            else {
                (0, jquery_1.default)("body").css({ overflow: "" });
            }
        });
    },
    loaded: function () {
        var hash = location.hash;
        var target = (0, jquery_1.default)(hash.replace('#', '#_'));
        var targetOffset = target.offset();
        if (targetOffset !== undefined) {
            setTimeout(function () {
                (0, jquery_1.default)('html, body').animate({ scrollTop: targetOffset.top }, 500, 'easeInOutExpo');
                return false;
            }, 500);
        }
    },
    pos: 0,
    scroll: function () {
        // $('.js-animeFadeIn, .c-ttl02, .c-ttl03').each((index, elm) => {
        //   let elmPt: number = $(elm).position().top;
        //   if(win.st() + win.h() > elmPt) {
        //     $(elm).addClass('is-active');
        //   }
        // });
        // ヘッダー制御
        var headerElm = (0, jquery_1.default)('.l-header');
        if (win.st() > 0) {
            if (win.st() < common.pos) {
                //上向きにスクロール
                headerElm.addClass('is-fixed');
            }
            else {
                //下向きにスクロールの時の処理
                headerElm.removeClass('is-fixed');
            }
            common.pos = win.st();
        }
        else {
            headerElm.removeClass('is-fixed');
        }
    }
};
var userAgent = {
    init: function () {
        var ua = navigator.userAgent;
        var device;
        if ((ua.indexOf("iPhone") > 0 || ua.indexOf("iPod") > 0 || ua.indexOf("Android") > 0 && ua.indexOf("Mobile") > 0) || (ua.indexOf("iPad") > 0 || ua.indexOf("Android") > 0)) {
            device = "is-sp";
        }
        else {
            device = "is-pc";
        }
        (0, jquery_1.default)('body').addClass(device);
    }
};
var win = {
    w: function () {
        return document.body.clientWidth;
    },
    h: function () {
        return document.documentElement.clientHeight;
    },
    st: function () {
        return window.scrollY;
    }
};
var isUser = {
    type: function (className) {
        if ((0, jquery_1.default)('body').hasClass(className)) {
            return true;
        }
        else {
            return false;
        }
    }
};
var btnScroll = {
    t: (0, jquery_1.default)('.js-scroll'),
    init: function () {
        btnScroll.t.on('click', function (event) {
            var hash = (0, jquery_1.default)(event.currentTarget).attr('href');
            if (hash !== undefined) {
                var target = (0, jquery_1.default)(hash.replace('#', '#_'));
                var targetOffset = target.offset();
                targetOffset !== undefined && (0, jquery_1.default)('html, body').animate({ scrollTop: targetOffset.top }, 500);
            }
            return false;
        });
    }
};
var home = {
    mvEnTxt01: (0, jquery_1.default)('.js-mvEnTxt01'),
    mvEnTxt02: (0, jquery_1.default)('.js-mvEnTxt02'),
    mvEnTxt01Inner: (0, jquery_1.default)('.js-mvEnTxt01Inner'),
    mvEnTxt02Inner: (0, jquery_1.default)('.js-mvEnTxt02Inner'),
    load: function () {
    },
    scroll: function () {
        (0, jquery_1.default)('.js-secItem').each(function (index, elm) {
            var elmPt = (0, jquery_1.default)(elm).position().top;
            if (win.st() + win.h() > elmPt) {
                (0, jquery_1.default)(elm).addClass("is-active");
                (0, jquery_1.default)(elm).find(".slide-in").addClass("slideAnimeLeftRight");
                (0, jquery_1.default)(elm).find(".slide-in_inner").addClass("slideAnimeRightLeft");
            }
        });
        // const mvEnTxt01 = $('.js-mvEnTxt01');
        // const mvEnTxt02 = $('.js-mvEnTxt02');
        // const mvEnTxt01Inner = $('.js-mvEnTxt01Inner');
        // const mvEnTxt02Inner = $('.js-mvEnTxt02Inner');
        var mvEnTxt01W = home.mvEnTxt01.width();
        var mvEnTxt02W = home.mvEnTxt02.width();
        var mvEnTxt01InnerW = home.mvEnTxt01Inner.width();
        var mvEnTxt02InnerW = home.mvEnTxt02Inner.width();
        var ratio = win.st() / (win.h() * .45);
        if (mvEnTxt01W !== undefined && mvEnTxt01InnerW !== undefined) {
            var mvEnTxt01Move = mvEnTxt01W - mvEnTxt01InnerW;
            home.mvEnTxt01Inner.css({ transform: "translateX(" + mvEnTxt01Move * ratio + "px)" });
            //console.log(ratio);
        }
        if (mvEnTxt02W !== undefined && mvEnTxt02InnerW !== undefined) {
            var mvEnTxt02Move = mvEnTxt02W - mvEnTxt02InnerW;
            home.mvEnTxt02Inner.css({ transform: "translateX(" + -mvEnTxt02Move * ratio + "px)" });
            //console.log(mvEnTxt02Move);
        }
    }
};
